function createAndUpdateUUID() {
  const Cookies = require('js-cookie')

  function createUUID() {
    let dt = new Date().getTime()
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
      }
    )

    return uuid
  }

  const uuid = Cookies.get('FPC') || createUUID()

  Cookies.set('FPC', uuid, { expires: 7, path: '/' })

  return uuid
}

function generatePixel({
  customerId,
  uuid,
  event = 'visit',
  pixelId = 'blisspoint',
  query = ''
}) {
  const existingPixel = document.getElementById(pixelId)

  if (existingPixel) {
    existingPixel.parentNode.removeChild(existingPixel)
  }

  const pixel = document.createElement('img')
  const fpc = uuid ? '&fpc=' + uuid : ''
  const userId = customerId ? '&user_id=' + customerId : ''
  const cacheBuster = '&cb=' + Math.floor(Math.random() * 10000000000000000)

  pixel.id = pixelId
  pixel.src = `https://pixel.pointmediatracker.com/kpi?c=hum&kpi=${event}&tag_id=70${fpc}${userId}${query}${cacheBuster}`
  pixel.style = 'display: none'

  document.body.appendChild(pixel)
}

export default function ({ app }) {
  app.router.afterEach(() => {
    const uuid = createAndUpdateUUID()
    const customerId = app.store.getters['user/customerId']

    generatePixel({ customerId, uuid })
  })

  app.$bus.$on('register', () => {
    const uuid = createAndUpdateUUID()
    const customerId = app.store.getters['user/customerId']

    generatePixel({
      customerId,
      uuid,
      event: 'register',
      pixelId: 'blisspoint-event'
    })
  })

  app.$bus.$on('checkout', orderDetails => {
    const uuid = createAndUpdateUUID()
    const customerId = app.store.getters['user/customerId']
    const query = `&order_id=${orderDetails.order.id}`

    generatePixel({
      customerId,
      uuid,
      event: 'order',
      pixelId: 'blisspoint-event',
      query
    })
  })
}
